module.exports = __webpack_public_path__ + "img/picture_teachvideo1@2x.7baf3510.png";